import * as XLSX from 'xlsx';

export const exportPpmRowsToExcel = (rows: any[], filename = 'ppm_report.xlsx') => {
  const data = rows.map((r) => ({
    'SECTION': r.ppmsection,
    'Ligne': `${r.accountcode || ''} ${r.accountname || ''}`,
    'Montant inscription budgétaire': r.montant_inscription_budgetaire,
    'Montant arriérés': r.montant_arrieres,
    'Crédits disponibles': r.credits_disponibles,
    'Activité': r.activite,
    'Nature de la prestation': r.nature_prestation,
    'Mode de passation': r.mode_passation,
    'Type de revue': r.type_revue,
    'Période de publication': r.periode_publication,
    'Période de remise des offres': r.periode_remise_offres,
    'Temps d’évaluation': r.temps_evaluation,
    'Date probable de démarrage': r.date_probable_demarrage,
    'Délai prévisionnel d’exécution': r.delai_previsionnel_execution,
    'Date de fin d’exécution': r.date_fin_execution,
    'Lot': r.lotno,
    'Superactivité': r.superactivityname,
  }));

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(wb, ws, 'PPM');
  XLSX.writeFile(wb, filename);
};
